import { blogs } from "../../data/blogs";
import { formatDate } from "../../utils/format";
import Button from "../ui/Button";
import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";

function BlogPreview() {
  return (
    <section id="blog" className="border-t border-border/70 py-16 sm:py-20">
      <Container>
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeader title="Blog" subtitle="Notes on product thinking, engineering, and building useful tools." />
          <Button as="a" href="/blog" variant="secondary" className="sm:mb-1">
            View All Articles
          </Button>
        </div>
        <div className="mt-9 grid gap-4 md:grid-cols-3">
          {blogs.map((blog) => (
            <a
              key={blog.id}
              href={blog.href}
              className="rounded-2xl border border-border/80 bg-surface/20 p-5 transition-all duration-200 ease-in-out hover:border-accent/35 hover:bg-surface/30 focus-visible:shadow-focus-ring"
            >
              <h3 className="text-base font-semibold leading-6 text-primary">{blog.title}</h3>
              <p className="mt-4 text-sm text-muted">
                <time dateTime={blog.date}>{formatDate(blog.date)}</time>
                <span aria-hidden="true"> · </span>
                {blog.readingTime}
              </p>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default BlogPreview;
